module.exports = __webpack_public_path__ + "img/green-ic.827786d6.svg";